'use client';

import { useField, useFormikContext } from 'formik';
import type { Accept } from 'react-dropzone';
import FormLabel from '@mui/material/FormLabel';
import FormHelperText from '@mui/material/FormHelperText';
import { makeStyles } from 'tss-react/mui';
import DropzoneArea from './dropzone-area';

const useStyles = makeStyles()(theme => ({
  label: {
    display: 'block',
    marginBottom: theme.spacing(1),
  },
}));

type DropzoneFileFieldProps = {
  name: string;
  label?: string;
  disabled?: boolean;
  touched?: boolean;
  className?: string;
  accept?: Accept;
  maxSize?: number;
  maxFiles?: number;
  placeholder?: string;
};

const DropzoneFileField = ({
  name,
  label,
  disabled,
  touched: formTouched,
  className,
  accept,
  maxSize,
  maxFiles,
  placeholder,
}: DropzoneFileFieldProps) => {
  const { classes } = useStyles();
  const [field, meta] = useField<File[]>(name);
  const { setFieldValue, setFieldTouched } = useFormikContext();
  const touched = formTouched || meta.touched;
  const error = touched && meta.error;

  return (
    <div className={className}>
      {label && (
        <FormLabel className={classes.label} htmlFor={name}>
          {label}
        </FormLabel>
      )}
      <DropzoneArea
        value={field.value ?? []}
        onChange={(files: File[]) => {
          setFieldValue(name, files);
          setFieldTouched(name, true);
        }}
        accept={accept}
        maxSize={maxSize}
        maxFiles={maxFiles}
        disabled={disabled}
        placeholder={placeholder}
      />
      {error && <FormHelperText error>{error}</FormHelperText>}
    </div>
  );
};

export default DropzoneFileField;
